import Project, {ProjectFile, ProjectId} from '@/types/Project';
import {BINARY_FILENAME} from '@/types/defs';
import RootState from '@/store/rootState';
import {Store} from 'vuex';
import {SubmissionId} from '@/types/Submission';

export const TEST_BINARY = new Uint8Array([0x60, 0x00]);
const SUBMISSION_VERSION = '1.0.0';

export function randomString(length: number): string {
    return Math.random().toString(36).substring(length);
}

export async function createRandomProject(store: Store<RootState>, name?: string, genres?: string[], version?: string): Promise<ProjectId> {
    const project: Project = {
        name: name ? name! : randomString(7),
        description: randomString(10),
        arch: 'x1',
        archVersion: version ?? 'latest',
        genres: genres ? genres! : ['sport', 'demo'],
        username: 'fake',
        language: 'assembly',
        uid: '',
    };
    const projectId = await store.dispatch('project/create', project);
    store.commit('project/CREATE_FILE', { name: BINARY_FILENAME, content: TEST_BINARY } as ProjectFile);
    await store.dispatch('project/updateFiles');
    return projectId;
}

export async function deleteProject(store: Store<RootState>, projectId: ProjectId): Promise<void> {
    await store.dispatch('project/delete', projectId);
}

export async function createAndSubmitProject(store: Store<RootState>, name?: string, genres?: [string], version?: string): Promise<[ProjectId, SubmissionId]> {
    const projectId = await createRandomProject(store, name, genres, version);
    const submissionId = await store.dispatch('submissions/submitProject', SUBMISSION_VERSION);
    return [projectId, submissionId];
}
